/* eslint-disable import/prefer-default-export */
import React from 'react'
import cx from 'classnames'
import { Routes } from '@src/constants/routes'

interface Props {
  className?: string
}

export const HelpLink: React.FC<Props> = React.memo(({ className }: Props) => (
  <a
    role={'nav-help'}
    className={cx(className)}
    target="_blank"
    rel="noopener noreferrer"
    href={Routes.onlineHelpPath}
  >
    <i className={'material-icons'}>help_outline</i>
  </a>
))
